import { statinModerateIntensityActivity } from './definitions/activities/statinModerateIntensity';
import { t2dmRoutineMonitoring } from './definitions/t2dmRoutineMonitoring';
import { insulinsValueSet, statinsValueSet, sulfonylureasValueSet } from './valueSets/rxNormDrugClasses';

/** The clinical protocols `@liza/medplum-config` deploys. */
export const planDefinitions = {
  t2dmRoutineMonitoring,
};

/** What the protocols' suggestion actions propose, referenced by `definitionCanonical` and deployed alongside them. */
export const protocolActivityDefinitions = {
  statinModerateIntensityActivity,
};

/** The terminology the protocols reference, deployed alongside them. */
export const protocolValueSets = {
  insulinsValueSet,
  statinsValueSet,
  sulfonylureasValueSet,
};
